import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
import {
  readActiveUserPackageCache,
  writeActiveUserPackageCache,
} from 'src/app/utils/active-user-package-cache.util';
@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(private api: ApiService) { }

  getCurrentUserActivePackage(
    data: any,
    options?: { forceRefresh?: boolean }
  ): Observable<any> {
    const clientId = data?.client_id;
    if (!options?.forceRefresh && clientId != null && clientId !== '') {
      const cached = readActiveUserPackageCache(clientId);
      if (cached != null) {
        return of(cached);
      }
    }

    return this.api.post(environment.getCurrentUserActivePackage, data).pipe(
      tap((res) => {
        if (clientId != null && clientId !== '') {
          writeActiveUserPackageCache(clientId, res);
        }
      })
    );
  }
  getAllPackage(data:any): Observable<any> {
    return this.api.post(environment.getAllPackage,data);
  }
  getAllInvoices(data:any): Observable<any> {
    return this.api.post(environment.getAllBillingInvoices,data);
  }
  getAllPackageAddon(data:any): Observable<any> {
    return this.api.post(environment.getAllPackageAddon,data);
  }
  proformaPackageInvoice(data:any): Observable<any> {
    return this.api.post(environment.proformaPackageInvoice,data);
  }
  cancelPendingPlanChange(data:any): Observable<any> {
    return this.api.post(environment.cancelPendingPlanChange, data);
  }
  schedulePlanChange(data:any): Observable<any> {
    return this.api.post(environment.schedulePlanChange, data);
  }
  proformaAddonInvoice(data:any): Observable<any> {
    return this.api.post(environment.proformaAddonInvoice,data);
  }
  getAllAddonSubscription(data:any): Observable<any> {
    return this.api.post(environment.getAllAddonSubscription,data);
  }
  createAddonSubscription(data:any): Observable<any> {
    return this.api.post(environment.createAddonSubscription,data);
  }
  updateAddonSubscription(data:any): Observable<any> {
    return this.api.post(environment.updateAddonSubscription,data);
  }
  getAddonSubscriptionById(data:any): Observable<any> {
    return this.api.post(environment.getAddonSubscriptionById,data);
  }
  deleteAddonSubscription(data:any): Observable<any> {
    return this.api.post(environment.deleteAddonSubscription,data);
  }
  createPackageSubscription(data:any): Observable<any> {
    return this.api.post(environment.createPackageSubscription,data);
  }
  updatePackageSubscription(data:any): Observable<any> {
    return this.api.post(environment.updatePackageSubscription,data);
  }
   getCurrentPackageFeatureAccess(data:any): Observable<any> {
    return this.api.post(environment.getCurrentPackageFeatureAccess,data);
  }
}


